import {
  Box,
  Button,
  Card,
  Divider,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import React, { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { decryptAES, isEmail } from '../common/helpers'
import {
  Center,
  EnqueueSnackbarType,
  showMessage,
} from '../components/common/Helpers'
import {
  actions as appActions,
  CompanyType,
  getCompanyInfo,
  RoleType,
  signup,
} from '../redux/appReducer'
import { StateType } from '../redux/store'
import { makeStyles } from '@mui/styles'
import GCLogoSrc from '../assets/GCLogo.png'
import GSLogoSrc from '../assets/GSLogo.png'

const defaultLogoSrc = window.location.hostname.includes('thegarageshop')
  ? GSLogoSrc
  : GCLogoSrc

interface IProps {
  company: undefined | CompanyType
  isCompanyInfoFetched: boolean

  signup(
    name: string,
    email: string,
    password: string,
    refEmail: string | undefined,
    enqueueSnackbar: EnqueueSnackbarType,
  ): void
  getCompanyInfo(email: string): void
  setIsCompanyInfoFetched(value: boolean): void
}

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  input: {
    marginBottom: '1rem',
    fontSize: '0.8rem',
  },
  logo: {
    width: '50%',
    marginBottom: '1rem',
    marginTop: '4rem',
  },
  card: {
    minWidth: 320,
    padding: '2rem 3rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // [theme.breakpoints.down('xs')]: {
    //     display: "none"
    // }
  },
}))

const Signup: FC<IProps> = (props) => {
  const styles = useStyles()

  const params = useParams<{ email: string | undefined }>()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (params.email) {
      props.getCompanyInfo(decryptAES(params.email))
    } else {
      props.setIsCompanyInfoFetched(true)
    }
  }, [])

  const handleSubmit = () => {
    if (!name) {
      showMessage(enqueueSnackbar, 'Name is required')
      return
    }
    if (!email) {
      showMessage(enqueueSnackbar, 'Email is required')
      return
    }
    if (!isEmail(email)) {
      showMessage(enqueueSnackbar, 'Email is invalid')
      return
    }
    if (!password) {
      showMessage(enqueueSnackbar, 'Password is required')
      return
    }

    props.signup(
      name,
      email,
      password,
      params.email ? decryptAES(params.email) : undefined,
      enqueueSnackbar,
    )
  }

  return (
    <Center>
      {props.isCompanyInfoFetched ? (
        <img
          className={styles.logo}
          src={props.company ? props.company.logoURL : defaultLogoSrc}
          alt="Logo"
        />
      ) : (
        <Skeleton
          variant="circular"
          animation="wave"
          className={styles.logo}
          height={173}
        />
      )}
      <Card className={styles.card}>
        <Typography style={{ fontWeight: 'bolder' }}>Create account</Typography>
        <Box className={styles.form}>
          <TextField
            label="Name"
            variant="outlined"
            value={name}
            onChange={(e) => {
              setName(e.target.value)
            }}
            style={{ width: '100%', marginTop: 15 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSubmit()
            }}
          />
          <TextField
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
            }}
            style={{ width: '100%', marginTop: 15 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSubmit()
            }}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
            }}
            style={{ width: '100%', marginTop: 15 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSubmit()
            }}
          />
          <Button
            style={{ marginTop: 15 }}
            size="medium"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            Sign up
          </Button>
        </Box>
        <Divider />
        <hr
          style={{
            margin: '15px',
            height: '1px',
            border: 0,
            borderTop: '1px solid hsl(0,0%,80%)',
            width: '100%',
          }}
        />
        <Link style={{ color: '#0052CC', fontSize: '14px' }} to="/login">
          Log In
        </Link>
      </Card>
    </Center>
  )
}

const mapStateToProps = (state: StateType) => ({
  company: state.appReducer.company,
  isCompanyInfoFetched: state.appReducer.isCompanyInfoFetched,
})

export default connect(mapStateToProps, {
  signup,
  getCompanyInfo,
  setIsCompanyInfoFetched: appActions.setIsCompanyInfoFetched,
})(Signup)
